module.exports = __webpack_public_path__ + "static/media/racecheck_logo_white.a1d995f9.svg";